import React, {useRef, useState} from 'react';
import {UsePermissions} from "../../../../hooks/usePermissions";

import {convertirModena} from "../../../../shared/utils/utils";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {UseLoader} from "../../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";

import {crearLiquidacion} from "../../../../api/liquidacion.service";

export const TableEditHora = ({liquidacion, factura, reload}) => {
    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions()
    const [totalSuma, setTotalSuma] = useState(0);
    const [totalSumaBruto, setTotalSumaBruto] = useState(0);
    const [totalSumaNeto, setTotalSumaNeto] = useState(0);

    const valorHoraBruto = factura.valor_factura / factura.cant_horas;
    const valorHoraNeta = factura.valor_neto / factura.cant_horas;

    const textEditor = (options) => {
        return <input
            id="valor"
            value={options.value}
            type="number"
            min="1"
            pattern="^[0-9]+"
            className="form-input-small "
            onChange={(e) => options.editorCallback(e.target.value)}
        />
    }

    const OnSave = () => {

        if (Math.round(totalSuma) > Math.round(factura.cant_horas) || Math.round(totalSuma) < Math.round(factura.cant_horas)) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: `La suma total de las horas debe ser al el valor facturado`,
                life: 3000
            });
            return;
        }

        if (Math.round(totalSumaBruto) > Math.round(parseFloat(factura.valor_factura)) || Math.round(totalSumaBruto) < Math.round(parseFloat(factura.valor_factura))) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: `La suma total facturada debe ser igual a la de la factura`,
                life: 3000
            });
            return;
        }


        if (Math.round(totalSumaNeto) > Math.round(parseFloat(factura.valor_neto)) || Math.round(totalSumaNeto) < Math.round(parseFloat(factura.valor_neto))) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: `La suma total neto facturado debe ser igual a la de la factura`,
                life: 3000
            });
            return;
        }
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () =>  {
                handleLoad(true);
                const payload = {
                    tipo: "H",
                    datos : liquidacion
                }
                const response = await crearLiquidacion(payload);

                handleLoad(false)

               if (response.estado !== 200) {
                    toast.current?.show({severity:'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }
                reload()
                toast.current?.show({severity:'success', summary: 'Exito', detail: response.mensaje, life: 3000});

            }
        });

    }


    const valorHorasTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {

            total += liq.cant_horas === '' ? 0 : Number(liq.cant_horas);

            liq.valor = liq.cant_horas === '' ? 0:  Number(liq.cant_horas) * valorHoraBruto;
            liq.valor_neto = liq.cant_horas === '' ? 0:  Number(liq.cant_horas) * valorHoraNeta;

        }


        setTotalSuma(total)
        return total;
    }

    const valorNetoTotal = () => {
        let total = 0;

        for (let liq of liquidacion) {

            total += liq.valor_neto === '' ? 0 : parseFloat(liq.valor_neto);

        }
        setTotalSumaNeto(total);
        return convertirModena(total);
    }

    const valorBrutoTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {
            total += liq.valor === '' ? 0 : parseFloat(liq.valor);
        }
        setTotalSumaBruto(total);
        return convertirModena(total);
    }

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={0} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorHorasTotal}/>
                <Column footer={valorBrutoTotal}/>
                <Column footer={valorNetoTotal}/>

            </Row>
            <Row>


            </Row>
        </ColumnGroup>;


    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={OnSave}
                >
                    <i className="fa fa-save"/>
                </button>
            </div>
        </div>
    );


    const onCellEditComplete = (e) => {
        let {rowData, newValue, field, originalEvent: event} = e;
        if (newValue.trim().length > 0) {
            rowData[field] = newValue;
        } else {
            event.preventDefault();
        }
    }

    const footer = (
        <div className="flex flex-col ">
            <p className={totalSuma > parseInt(factura.cant_horas) ? 'p-2  text-sm text-red-600' : 'p-2 text-sm text-teal-600 '}>
                Cantidad total horas: {factura.cant_horas}</p>
            <p className="p-2  text-sm">Valor jornada bruta: { convertirModena(valorHoraBruto)}</p>
            <p className="p-2  text-sm">Valor jornada neta: {convertirModena(valorHoraNeta)}</p>
        </div>
    );


    return (
        <>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={liquidacion}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                footer={footer}
                scrollable scrollHeight="400px"
                footerColumnGroup={footerGroup}
                responsiveLayout="scroll">
                <Column filter sortable field="afiliados" header="Afiliados" style={{width: '10%'}}></Column>
                <Column field="cant_horas" header="Cantidad de horas"
                        onCellEditComplete={onCellEditComplete}
                        editor={(options) => textEditor(options)} style={{width: '10%'}}></Column>
                <Column field="valor" header="Valor bruto" style={{width: '10%'}}></Column>
                <Column field="valor_neto" header="Valor Neto" style={{width: '10%'}}></Column>

            </DataTable>
        </>
    );
};


